import React from 'react';

import BadgeBase from './BadgeBase';
import TEBadgeSignal from '../../types/TEBadgeSignal';

const Brand = (props) => <BadgeBase {...props} signal={TEBadgeSignal.Brand} />;

export default Brand;
